<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
/**
 * Report component
 */
export default {
    components: { Layout, PageHeader, VueLoading },
    data() {
        return {
            tableData: [],
            title: "Report Engine Status",
            items: [
                {
                    text: "Report Engine",
                    href: "/",
                },
                {
                    text: "Status",
                    active: true,
                },
            ],
            currentPage: 1,
            perPage: 100,
            pageOptions: [5, 10, 25, 50, 100],
            sdType: "",
            filter: null,
            filterOn: [],
            fields: [
                {
                    key: "FLD01",
                    sortable: false,
                    tdClass: "minWidth200",
                    label: "レポートエンジン",
                },
                {
                    key: "FLD02",
                    sortable: false,
                    tdClass: "minWidth200",
                    label: "実行開始時刻",
                },
                {
                    key: "FLD03",
                    sortable: false,
                    tdClass: "minWidth100",
                    label: "処理対象/検査完了",
                },
                {
                    key: "FLD05",
                    sortable: false,
                    tdClass: "minWidth100",
                    label: "Status",
                },
            ],
            loading: false,
        };
    },
    validations: {},
    mounted() {
        this.getUser("user");
        this.search();
    },
    computed: {
        /**
         * Total no. of records
         */
        rows() {
            return this.tableData.length;
        },
    },
    methods: {
        search() {
            this.loading = true;
            axios
                .get("/api/status")
                .then((response) => {
                    this.loading = false;
                    this.tableData = response.data;
                })
                .catch((error) => {
                    this.loading = false;
                    this.errorProcess(error);
                });
        },
    },
};
</script>
<style>
.minWidth100 {
    min-width: 100px;
}
.minWidth200 {
    min-width: 200px;
}
.minWidth300 {
    min-width: 300px;
}
.modal-mask {
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-2">
                            <div class="col-sm-12 col-md-12">
                                <div
                                    id="tickets-table_filter"
                                    class="text-md-end"
                                >
                                    <button
                                        class="btn btn-primary"
                                        type="button"
                                        @click="search"
                                    >
                                        更新
                                    </button>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row mt-3">
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                        style="white-space: nowrap"
                                    >
                                        表示&nbsp;
                                        <b-form-select
                                            v-model="perPage"
                                            size="sm"
                                            class="form-select form-select-sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;行
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div class="text-md-end">
                                    <label
                                        class="d-inline-flex align-items-center"
                                        style="white-space: nowrap"
                                    >
                                        フィルタ:
                                        <b-form-input
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="form-control ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                striped
                                hover
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                            ></b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                    class="dataTables_paginate paging_simple_numbers float-end"
                                >
                                    <ul
                                        class="pagination pagination-rounded mb-0"
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
        <div v-if="loading" class="modal-mask">
            <vue-loading
                type="spiningDubbles"
                color="#eee"
                :size="{ width: '50px', height: '50px' }"
            ></vue-loading>
        </div>
    </Layout>
</template>
